import { createContext, useContext } from 'react'

type MobileAppContextType = {
  hasMobileAppAccess: boolean | undefined
  clearMobileAppAccess: () => void
}

export const MobileAppContext = createContext<MobileAppContextType>({
  hasMobileAppAccess: undefined,
  clearMobileAppAccess: () => {},
})

export const useMobileAppAccess = () => useContext(MobileAppContext)
